import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Layers, Moon, Wind, Home } from 'lucide-react';
export function ProductIntro() {
  return <section className="py-24 px-6 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-222">
      <div className="max-w-4xl mx-auto text-center" data-id="element-223">
        <FadeIn data-id="element-224">
          <span className="inline-block px-4 py-1 rounded-full bg-amber-500/10 text-amber-400 text-sm font-bold tracking-wide mb-6 border border-amber-500/20" data-id="element-225">
            SOLUCIÓN
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-226">
            CLUB DE LAS 3AM
          </h2>
          <p className="text-xl text-slate-400 mb-16" data-id="element-227">Mini Kit de Rescate</p>
        </FadeIn>

        <FadeIn delay={200} data-id="element-228">
          <div className="bg-slate-800/30 p-8 md:p-12 rounded-3xl border border-slate-700 backdrop-blur-sm mb-16" data-id="element-229">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-230">
              El corazón del kit:{' '}
              <span className="text-amber-400" data-id="element-231">El Interruptor 3AM</span>
            </h3>
            <p className="text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-232">
              Un reinicio de 12 minutos en 3 capas. Tu meta no es dormir
              perfecto, es volver a un estado donde el sueño sea posible.
            </p>

            <div className="grid md:grid-cols-3 gap-8" data-id="element-233">
              <div className="p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-amber-500/30 transition-colors" data-id="element-234">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mx-auto mb-4" data-id="element-235">
                  <Wind className="text-blue-400" data-id="element-236" />
                </div>
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-237">1. CUERPO</h4>
                <p className="text-sm text-slate-400" data-id="element-238">
                  Bajar la activación sin volverte loca "respirando perfecto".
                </p>
              </div>

              <div className="p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-amber-500/30 transition-colors" data-id="element-239">
                <div className="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center mx-auto mb-4" data-id="element-240">
                  <Moon className="text-purple-400" data-id="element-241" />
                </div>
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-242">2. MENTE</h4>
                <p className="text-sm text-slate-400" data-id="element-243">
                  Cortar la narrativa de amenaza sin pelear con pensamientos.
                </p>
              </div>

              <div className="p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-amber-500/30 transition-colors" data-id="element-244">
                <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-4" data-id="element-245">
                  <Home className="text-amber-400" data-id="element-246" />
                </div>
                <h4 className="text-lg font-bold text-white mb-2" data-id="element-247">
                  3. ENTORNO
                </h4>
                <p className="text-sm text-slate-400" data-id="element-248">
                  Reentrenar tu cama para que vuelva a significar descanso.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}